import { IUsersState } from './store';
import { UsersActions, UsersActionTypes } from './actionTypes';
import { ExtendedUser } from './types';

const initialState: IUsersState = {
  waitingForStatusUsers: [],
};

export function usersReducer(
  state = initialState,
  action: UsersActions
): IUsersState {
  switch (action.type) {
    case UsersActionTypes.FETCH_USERS_SUCCESS:
      return {
        ...state,
        users: action.users,
        status: 200,
      };
    case UsersActionTypes.FETCH_USERS_ERROR:
      return {
        ...state,
        status: action.status,
      };
    case UsersActionTypes.POST_USERS_SUCCESS:
      return {
        ...state,
        users: [
          ...(state.users || []).filter(
            (_user) =>
              !action.users.some(
                (user) =>
                  _user.userName.toLowerCase() === user.userName.toLowerCase()
              )
          ),
          ...action.users,
        ],
        status: action.status,
        message: 'post',
      };
    case UsersActionTypes.POST_USERS_ROLES_SUCCESS:
      const newUsers: ExtendedUser[] = JSON.parse(JSON.stringify(state.users));

      action.userRolesInformation.users.forEach((user) => {
        const i = newUsers.findIndex((x) => x.userName === user.userName);
        newUsers[i].userRoles = [];
        action.userRolesInformation.usersRoles.forEach((rol) => {
          const roleExists = newUsers[i].userRoles.find(
            (x) => x === rol.roleDisplayName
          );
          if (!roleExists) {
            newUsers[i].userRoles.push(rol.roleDisplayName || rol.roleName);
          }
        });
      });

      return {
        ...state,
        users: newUsers,
        waitingForStatusUsers: action.userRolesInformation.users.map((u) =>
          u.userName.toLowerCase()
        ),
        status: 200,
        message: 'post',
      };
    case UsersActionTypes.POST_SINGLE_USER_ROLE_SUCCESS:
      const createdUsers: ExtendedUser[] = JSON.parse(
        JSON.stringify(state.users)
      );
      const index = createdUsers.findIndex(
        (x) => x.userName === action.singleUsersRolesInformation.user.userName
      );
      createdUsers[index].userRoles = [];
      action.singleUsersRolesInformation.usersRoles.forEach((rol) => {
        const exists = createdUsers[index].userRoles.find(
          (x) => x === rol.roleDisplayName
        );
        if (!exists) {
          createdUsers[index].userRoles.push(
            rol.roleDisplayName || rol.roleName
          );
        }
      });

      return {
        ...state,
        users: createdUsers,
        waitingForStatusUsers: [
          action.singleUsersRolesInformation.user.userName.toLocaleLowerCase(),
        ],
        status: 200,
        message: 'post',
      };
    case UsersActionTypes.CLEAR_WAITING_FOR_USERS:
      return {
        ...state,
        waitingForStatusUsers: (state.waitingForStatusUsers || []).filter(
          (username) => action.userNames.indexOf(username.toLowerCase()) === -1
        ),
      };
    case UsersActionTypes.DELETE_USER_SUCCESS:
      return {
        ...state,
        users: state.users?.filter(
          (_user) => _user.userName !== action.userName
        ),
        status: 200,
        message: 'delete',
      };
    case UsersActionTypes.PATCH_USER_SUCCESS:
      const newUsersPatch: ExtendedUser[] = JSON.parse(
        JSON.stringify(state.users)
      );
      const patchUserIndex = newUsersPatch.findIndex(
        (x) => x.userName == action.user.userName
      );
      newUsersPatch[patchUserIndex] = action.user;
      return {
        ...state,
        users: newUsersPatch,
        status: 200,
        message: 'patch',
      };
    case UsersActionTypes.PUT_USER_SUCCESS:
      const newUsersPut: ExtendedUser[] = JSON.parse(
        JSON.stringify(state.users)
      );
      const updatedUserIndex = newUsersPut.findIndex(
        (x) => x.userName == action.user.userName
      );
      newUsersPut[updatedUserIndex] = action.user;
      return {
        ...state,
        users: newUsersPut,
        status: 200,
        message: 'put',
      };
    case UsersActionTypes.FETCH_PORTALS_REQUEST:
      return {
        ...state,
        userAccess: { userPortalAccess: [], loading: true },
      };
    case UsersActionTypes.FETCH_PORTALS_ERROR: {
      return {
        ...state,
        userAccess: { userPortalAccess: [], loading: false },
      };
    }
    case UsersActionTypes.FETCH_PORTALS_SUCCESS:
      return {
        ...state,
        userAccess: {
          ...action.userAccess,
          loading: false,
        },
      };
    case UsersActionTypes.DELETE_USER_ERROR:
    case UsersActionTypes.PATCH_USER_ERROR:
    case UsersActionTypes.PUT_USER_ERROR:
    case UsersActionTypes.POST_USERS_ERROR:
    case UsersActionTypes.POST_USERS_ROLES_ERROR:
    case UsersActionTypes.POST_RESET_PASSWORD_ERROR:
      return {
        ...state,
        status: action.status,
        message: action.message,
      };
    case UsersActionTypes.CLEAR_USERS_ERROR:
      return {
        ...state,
        status: undefined,
        message: undefined,
      };
    case UsersActionTypes.CLEAR_USER_ROLE_INFORMATION:
      return {
        ...state,
        user: undefined,
      };
    case UsersActionTypes.GET_USER_ROLE_INFORMATION:
      return {
        ...state,
        user: action.user,
      };
    case UsersActionTypes.GET_USER_ROLE_INFORMATION_ERROR:
      return {
        ...state,
        status: action.status,
      };
    case UsersActionTypes.GET_USER_IDENTITY_SUCCESS:
      return {
        ...state,
        userIdentityInfo: action.userIdentityInfo,
      };
    case UsersActionTypes.GET_USER_IDENTITY_ERROR:
      return {
        ...state,
        userIdentityInfo: action.userIdentityInfo,
      };
    case UsersActionTypes.CLEAR_USER_IDENTITY:
      return {
        ...state,
        userIdentityInfo: undefined,
      };
  }
  return state;
}
